import {
  BATCH_STATUS_LABELS,
  BATCH_STATUS_STYLES,
} from "../../utils/reportcard/reportCardHelpers";

export default function BatchStatusBadge({ status }) {
  if (!status) return null;
  return (
    <span
      className={`inline-flex items-center text-[11px] font-medium px-2 py-0.5 rounded-full ${ BATCH_STATUS_STYLES[status] || "bg-gray-100 dark:bg-neutral-900 text-gray-600 dark:text-neutral-300" }`}
    >
      {BATCH_STATUS_LABELS[status] || status}
    </span>
  );
}
